import styled, { css } from 'styled-components'

export const FilterContainer = styled.div`
  flex: 0 1 auto;
  font-size: 1.6rem;
  font-weight: 300;
  cursor: pointer;
  text-align: left;

  svg {
    display: none;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      width: 22px;
      height: 10px;
      display: inline-block;
      margin-left: 2.5rem;
      transform: rotate(180deg);
      transition: all 0.3s;

      ${props => props.open && css`
        transform: rotate(0deg);
      `};
    }
  }

  ul {
    background: ${props => props.theme.colors.white};
    padding: 2rem;
    margin: 1.2rem -2rem;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      background: transparent;
      padding: 0;
      margin: 0.5rem 0 3.2rem;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);

      ${props => props.open && css`
        height: auto;
        max-height: 90rem;
        transition: all 1s ease-in-out;
      `};
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 2rem;
    margin-right: 5rem;
  }
`

export const FilterOptions = styled.div`
  display: block;
  font-size: 1.4rem;
  line-height: 2.5714;
`

export const FilterOption = styled.li`
  position: relative;
  cursor: pointer;
  line-height: 1;
  padding: 1.2rem 0;
  text-align: left;

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 1.2rem;
    right: 2rem;
    width: 14px;
    height: 14px;
    border-radius: 2rem;
    border: 1px solid ${props => props.theme.colors.black};
  }

  ${props => props.active && css`
    color: ${props => props.theme.colors.cobalt};

    &::after {
      background-color: ${props => props.theme.colors.cobalt};
      border: 1px solid ${props => props.theme.colors.cobalt};
    }
  `};

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    &::after {
      content: none;
    }

    &::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      width: 8px;
      height: 8px;
      border-radius: 1rem;
      border: 1px solid ${props => props.theme.colors.black};
      margin-right: 1.75rem;
      margin-top: -0.2rem;
    }

    ${props => props.active && css`
      &::before {
        background-color: ${props => props.theme.colors.cobalt};
        border: 1px solid ${props => props.theme.colors.cobalt};
      }
    `};
  }
`

export const ResetLink = styled.button`
  display: none;
  font-size: 1.4rem;
  margin-top: 1.5rem;
  color: ${props => props.theme.colors.black};
  text-decoration: underline;
  cursor: pointer;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: block;
  }
`
